import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

import './images/general_modal_close.svg'

// アニメーションの終了を待つ処理
const waitAnimation = (element) => Promise.allSettled(
  Array.from(element.getAnimations()).map(animation => animation.finished)
)

const showGeneralModal = () => {
  const DIALOG_TARGET_SELECTOR = '.js-showGeneralModal-dialog-target'

  // モーダルを開く処理
  const openDialog = (dialog) => {
    if ($(dialog).is(':animated')) return // アニメーション中の場合は処理しない

    dialog.showModal()
    dialog.setAttribute('data-activate', 'true')
  }

  // モーダルを閉じる処理
  const closeDialog = async (dialog) => {
    if ($(dialog).is(':animated')) return // アニメーション中の場合は処理しない

    dialog.setAttribute('data-activate', 'false')
    await waitAnimation(dialog)
    dialog.close()
  }

  // 開くトリガーのイベント設定
  $('[data-modal-open-for]').on('click', (event) => {
    const targetDialog = document.querySelector(`#${event.currentTarget.getAttribute('data-modal-open-for')}`)
    openDialog(targetDialog)
  })

  // 閉じるトリガーのイベント設定
  $('[data-modal-close]').on('click', (event) => {
    const targetDialog = event.currentTarget.closest('dialog')
    closeDialog(targetDialog)
  })

  // オーバーレイのイベント設定
  $(DIALOG_TARGET_SELECTOR).on('click', (event) => {
    if (event.target === event.currentTarget) {
      const targetDialog = event.currentTarget
      closeDialog(targetDialog)
    }
  })
}

$(() => {
  // 汎用モーダルの表示処理
  showGeneralModal()
})
